import type { FaireProductEntity } from "../../entity_types/product";

export const p_huauuegq65: FaireProductEntity = {
  token: "p_huauuegq65",
  type: "product",
  name: "Makeup Remover Cleansing Balm",
  brandToken: "b_3z46kjdoak",
  brandName: "Plant Therapy",
  imageUrl:
    "https://cdn.faire.com/fastly/ee30e7204ab0328bdffe0abf851f80d7694a9f0d18aa95e00a10829bb862f684.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6381f34ed43f74ad896c727446cdd21b9fb767876341137e9c53930859d9b8d2.webp",
    "https://cdn.faire.com/fastly/ec850ac7ad6b6ac902f57467c4b7ac850de56c6d036ff9618aff059efd5c1e18.webp",
    "https://cdn.faire.com/fastly/a1ae0326124015ff64ca5b595fd135d0a49e1ac94ed9fe675df279dd463af2ce.webp",
    "https://cdn.faire.com/fastly/b03f611853b46185757973fc417a5d09aafe4b33ed4a7d50bcf99704181352e0.jpeg",
    "https://cdn.faire.com/fastly/4a56c41a0730c683dd6887d5a74bb53fb09d0800887fac4f11f386fd3de6c6cc.jpeg",
    "https://cdn.faire.com/fastly/f1bc84f03977411392dc0e298e72315bdc5b38b650e75d4ee1c7dce6de2d9c41.webp",
  ],
  priceDollars: 8,
  description:
    "Experience the perfect blend of gentle cleansing and deep nourishment with our all-natural, vegan Makeup Remover Balm. Enriched with skin-loving ingredients like Argan and Sweet Almond oils, this balm effortlessly melts away even the toughest waterproof makeup and impurities, leaving your skin clean without feeling stripped. It's safe for use around your eyes, making it an excellent option for removing eye makeup without irritation. \n\nCandelilla and Carnauba waxes provide a smooth, silky texture, while Squalane and Baobab Seed Oil work together to lock in moisture, ensuring your skin feels soft, supple, and hydrated after every use. Vitamin E adds an extra layer of protection and nourishment, making this balm ideal for maintaining a healthy glow. \n\nFree from fragrances, it’s perfect for even the most sensitive skin types, offering a soothing cleanse without irritation. Indulge in a skincare ritual that not only removes makeup but pampers your skin with every application.",
  tags: [],
  msrpDollars: 15.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:52.347Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
